/* eslint-disable react/prop-types */
import {
  Button,
  Center,
  Checkbox,
  HStack,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Spacer,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { RiErrorWarningFill } from 'react-icons/ri';
import { data } from '../Sidebar/DataMenu';
import { extractPaths } from '../../Utils/roleAccessUtils';

function AccessPathTabs({ access, setAccess, changes }) {
  const paths = data;
  const accessList = extractPaths(paths);
  const actionList = ['Create', 'Read', 'Update', 'Delete'];

  const AccessButton = ({ section, index }) => {
    const [temp, setTemp] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handlePopUp = () => {
      setTemp(JSON.parse(JSON.stringify(access?.[index])));
      onOpen();
    };

    const handleSelectAll = (isChecked) => {
      if (isChecked)
        setTemp((prev) => {
          const newTemp = [...prev];
          newTemp.map((x) => (x.action = ['create', 'read', 'update', 'delete']));

          return newTemp;
        });
      else setTemp((prev) => {
        const newTemp = [...prev];
        newTemp.map((x) => (x.action = []));

        return newTemp;
      });
    };

    const handleCheck = (action, pathIdx) => {
      setTemp((prev) => {
        const newTemp = [...prev];
        const idx = newTemp[pathIdx].action.findIndex((x) => x === action);
        if (idx > -1) newTemp[pathIdx].action.splice(idx, 1);
        else newTemp[pathIdx].action.push(action);

        return newTemp;
      });
    };

    const handleSave = () => {
      setAccess((prev) => {
        const newAccess = [...prev];
        newAccess[index] = temp;

        return newAccess;
      });
    };

    return (
      <>
        <HStack
          h="80px"
          borderRadius="10px"
          borderWidth="1px"
          borderColor="gray.100"
          boxShadow="md"
          px="16px"
          position="relative"
          cursor="pointer"
          onClick={handlePopUp}
        >
          <Icon as={section?.icon} fontSize="36px" />
          <Text fontWeight={500}>{section?.name}</Text>
          {access[index]?.some((x) => changes?.some((y) => x?.path === y?.path)) && (
            <Center position="absolute" top="10px" right="10px">
              <Icon as={RiErrorWarningFill} fontSize="20px" color="red.500" />
            </Center>
          )}
        </HStack>

        <Modal isOpen={isOpen} onClose={onClose} size="xl">
          <ModalOverlay />
          <ModalContent>
            <HStack>
              <ModalHeader>Akses</ModalHeader>
              <Spacer />
              <Checkbox colorScheme="green" pr="24px" onChange={(e) => handleSelectAll(e.target.checked)}>
                <Text fontSize="14px">Select all</Text>
              </Checkbox>
            </HStack>
            <ModalBody>
              <TableContainer maxH="600px" overflow="auto">
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th>Halaman</Th>
                      <Th>Rincian Akses</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {temp?.map((x, i) => (
                      <Tr key={i}>
                        <Td>
                          <HStack>
                            <Text>{accessList?.[index]?.find((a) => a?.path === x?.path)?.name}</Text>
                            {changes?.some((y) => x?.path === y?.path) && (
                              <Center>
                                <Icon as={RiErrorWarningFill} fontSize="20px" color="red.500" />
                              </Center>
                            )}
                          </HStack>
                        </Td>
                        <Td>
                          <HStack>
                            {actionList.map((y, j) => (
                              <Checkbox
                                key={j}
                                isChecked={x?.action?.includes(y.toLowerCase())}
                                colorScheme="green"
                                onChange={() => handleCheck(y.toLowerCase(), i)}
                              >
                                <Text fontSize="14px">{y}</Text>
                              </Checkbox>
                            ))}
                          </HStack>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </ModalBody>
            <ModalFooter>
              <Button variant="ghost" mr={3} onClick={onClose}>
                Batal
              </Button>
              <Button colorScheme="green" onClick={() => handleSave()}>
                Simpan
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  };

  return (
    <>
      <SimpleGrid columns={3} gap="10px">
        {paths?.map((x, i) => (
          <AccessButton key={i} section={x} index={i} />
        ))}
      </SimpleGrid>
    </>
  );
}

export default AccessPathTabs;
